export default "__VITE_ASSET__B_gx02ZU__"